import { create } from "zustand";

export interface AnnouncerState {
  /** Latest message for the polite live region. */
  readonly message: string;
  /** Monotonic counter so repeated identical messages are re-announced. */
  readonly seq: number;
  announce: (message: string) => void;
}

export const useAnnouncerStore = create<AnnouncerState>()((set, get) => ({
  message: "",
  seq: 0,
  announce: (message) => set({ message, seq: get().seq + 1 }),
}));
